import { render, staticRenderFns } from "./FinalExamProtocolsRanging.vue?vue&type=template&id=24c352f0"
import script from "./FinalExamProtocolsRanging.vue?vue&type=script&lang=js"
export * from "./FinalExamProtocolsRanging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports